module.exports = __webpack_public_path__ + "assets/ic-talk.db8630dd.svg";